import { SearchInputOption } from '@abyss/web/ui/SearchInput';
import { useLazyQuery } from '@apollo/client';
import { GET_SEARCH_SUGGESTIONS } from '@pass-frontend/common/data-access';
import { SponsorSearchSuggestion } from '@pass-frontend/data-access/common/edge';

// maps the raw suggestion shape to what SearchInput expects, keeping sponsorId/eligibility around for callers
const toSponsorSearchInputOptions = (
  suggestions?: SponsorSearchSuggestion[],
): SearchInputOption[] =>
  (suggestions ?? []).map(
    ({ vanityName, sponsorId, isAssumedEligibleSponsor }) => ({
      value: sponsorId,
      label: vanityName,
      isAssumedEligibleSponsor,
    }),
  );

export function useSponsorLookupSuggestion() {
  const [fetchSponsorLookupSuggestions, { loading, error, data }] =
    useLazyQuery<{
      getSearchSuggestions: SponsorSearchSuggestion[];
    }>(GET_SEARCH_SUGGESTIONS);

  return {
    loading: loading ?? false,
    error,
    sponsorSuggestions: toSponsorSearchInputOptions(data?.getSearchSuggestions),
    /**
     * @param limit - max number of suggestions to request; capped server-side at 10
     * regardless of the value passed (see `validateLimit` in `sponsor-lookup.data-provider.ts`).
     */
    fetchSponsorLookupSuggestions: (searchInput: string, limit?: number) => {
      fetchSponsorLookupSuggestions({
        variables: { searchInput, limit },
      });
    },
  };
}
